import "babel-polyfill"; // for < ie 11 compatibility
import React from 'react';
import ReactDOM from 'react-dom';
import FontFaceObserver from 'fontfaceobserver';

import App from './components/App';

import registerServiceWorker from './registerServiceWorker';

// Import CSS reset and Global Styles
import './global-styles';

// Observe loading of Open Sans (to remove open sans, remove the <link> tag in
// the index.html file and this observer)
const fontBoldObserver = new FontFaceObserver('Source Sans Pro', { weight: 700 });
const fontRegularObserver = new FontFaceObserver('Source Sans Pro', { weight: 400 });

// When fonts are loaded, add font-family to the body
Promise.all([
  fontBoldObserver.load(),
  fontRegularObserver.load(),
]).then(() => {
  document.body.classList.add('fontLoaded');
}, () => {
  document.body.classList.remove('fontLoaded');
});


ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js